export const communication = {
    digitalMaterial: "Digital material",
    tastings: "Tastings",
    storeMaterial: "Store material",
    campaignMaterial: "Campaign material",
    news: "News",
};
